import React from 'react';

import { QHeading, QTabs, QFlex, QSpinner, QCenter, QCloseButton, QSpacer, QDivider } from '@qualio/ui-components';
import { useConfigsQuery } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { routes } from 'utils';

import { activeRouteId, TABS } from './constants';

export const SupplierPolicyConfigurationView: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    isConfigsLoading,
    supplierTypeOptions,
    riskTypeOptions,
    auditTypeOptions,
    documentTypeOptions,
    refetchConfigs,
    configs,
  } = useConfigsQuery();

  // Translate tabs at runtime
  const tabTitleMap: Record<string, string> = {
    supplier: t('policyConfiguration.tabs.supplierTypes'),
    risk: t('policyConfiguration.tabs.riskLevels'),
    document: t('policyConfiguration.tabs.documentTypes'),
    audit: t('policyConfiguration.tabs.auditTypes'),
  };
  const translatedTabs = TABS.map((tab) => ({
    ...tab,
    title: tabTitleMap[tab.id] || tab.title,
  }));

  return (
    <>
      <QFlex align="center" mb={2}>
        <QHeading size={'lg'}>{t('policyConfiguration.heading')}</QHeading>
        <QSpacer />
        <QCloseButton onClick={() => navigate(`/${routes.policy.root}/${routes.policy.documents}`)} />
      </QFlex>
      <QDivider />
      {isConfigsLoading ? (
        <QCenter p={5}>
          <QSpinner />
        </QCenter>
      ) : (
        <QFlex flexDirection="row" mt={4}>
          <QTabs
            orientation="vertical"
            activeTabId={activeRouteId(pathname)}
            tabs={translatedTabs}
            onClick={(tabItem) => navigate(`/settings/${tabItem.id}`)}
          />
          {isConfigsLoading ? (
            <QSpinner />
          ) : (
            <Outlet
              context={{
                isConfigsLoading,
                supplierTypeOptions,
                riskTypeOptions,
                auditTypeOptions,
                documentTypeOptions,
                refetchConfigs,
                configs,
              }}
            />
          )}
        </QFlex>
      )}
    </>
  );
};

export type OutletSupplierPolicyConfigurationType = {
  isConfigsLoading: boolean;
  supplierTypeOptions: any;
  riskTypeOptions: any;
  auditTypeOptions: any;
  documentTypeOptions: any;
  configs: any;
  refetchConfigs: () => void;
};

export const useRouterOutletSupplierPolicyConfiguration = (): OutletSupplierPolicyConfigurationType => {
  return useOutletContext<OutletSupplierPolicyConfigurationType>();
};
